import styled, { css } from "styled-components";
import { useDesignTokens } from "@boi/react-design-tokens";
import { ChevronDownIcon } from "@boi/react-icons";

export const ChevronIcon = styled(ChevronDownIcon)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { select } = tokens;

    return css`
      display: block;
      width: ${select.button.icon.width};
      height: ${select.button.icon.height};
      color: ${select.button.icon.color.base};

      .react-aria-Select [data-hovered] &,
      .react-aria-ComboBox [data-hovered] & {
        color: ${select.button.icon.color.hover};
      }

      .react-aria-Select[data-open] &,
      .react-aria-ComboBox[data-open] & {
        color: ${select.button.icon.color.active};
        rotate: 180deg;
      }

      .react-aria-Select[data-disabled] &,
      .react-aria-ComboBox[data-disabled] & {
        color: ${select.button.icon.color.disabled};
      }
    `;
  }}
`;
